<template>
  <svg
    width="19.85px"
    height="17px"
    viewBox="0 0 19.85 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="side-menu"
        transform="translate(-32, -440)"
        fill="#FFFFFF"
        fill-rule="nonzero"
      >
        <g
          id="manage_accounts_FILL1_wght400_GRAD0_opsz24"
          transform="translate(32, 440)"
        >
          <path
            id="Shape"
            d="M14,17 L13.7,15.5 C13.5,15.4166667 13.3125,15.3291667 13.1375,15.2375 C12.9625,15.1458333 12.7833333,15.0333333 12.6,14.9 L11.15,15.35 L10.15,13.65 L11.3,12.65 C11.2666667,12.4166667 11.25,12.2 11.25,12 C11.25,11.8 11.2666667,11.5833333 11.3,11.35 L10.15,10.35 L11.15,8.65 L12.6,9.1 C12.7833333,8.96666667 12.9625,8.85416667 13.1375,8.7625 C13.3125,8.67083333 13.5,8.58333333 13.7,8.5 L14,7 L16,7 L16.3,8.5 C16.5,8.58333333 16.6875,8.675 16.8625,8.775 C17.0375,8.875 17.2166667,9 17.4,9.15 L18.85,8.65 L19.85,10.4 L18.7,11.4 C18.7333333,11.6 18.75,11.8083333 18.75,12.025 C18.75,12.2416667 18.7333333,12.45 18.7,12.65 L19.85,13.65 L18.85,15.35 L17.4,14.9 C17.2166667,15.0333333 17.0375,15.1458333 16.8625,15.2375 C16.6875,15.3291667 16.5,15.4166667 16.3,15.5 L16,17 L14,17 Z M0,16 L0,13.2 C0,12.65 0.141666667,12.1333333 0.425,11.65 C0.708333333,11.1666667 1.1,10.8 1.6,10.55 C2.45,10.1166667 3.40833333,9.75 4.475,9.45 C5.54166667,9.15 6.71666667,9 8,9 L8.35,9 C8.45,9 8.55,9.01666667 8.65,9.05 C8.16666667,10.25 7.96666667,11.4416667 8.05,12.625 C8.13333333,13.8083333 8.53333333,14.9333333 9.25,16 L0,16 Z M15,14 C15.55,14 16.0208333,13.8041667 16.4125,13.4125 C16.8041667,13.0208333 17,12.55 17,12 C17,11.45 16.8041667,10.9791667 16.4125,10.5875 C16.0208333,10.1958333 15.55,10 15,10 C14.45,10 13.9791667,10.1958333 13.5875,10.5875 C13.1958333,10.9791667 13,11.45 13,12 C13,12.55 13.1958333,13.0208333 13.5875,13.4125 C13.9791667,13.8041667 14.45,14 15,14 Z M8,8 C6.9,8 5.95833333,7.60833333 5.175,6.825 C4.39166667,6.04166667 4,5.1 4,4 C4,2.9 4.39166667,1.95833333 5.175,1.175 C5.95833333,0.391666667 6.9,0 8,0 C9.1,0 10.0416667,0.391666667 10.825,1.175 C11.6083333,1.95833333 12,2.9 12,4 C12,5.1 11.6083333,6.04166667 10.825,6.825 C10.0416667,7.60833333 9.1,8 8,8 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>
